<template>
		<div>
				<AppBar></AppBar>
				<div class="page-content header-clear-medium">
						<div class="card card-style">
								<div class="content mt-4 mb-0">
										<h1 class="text-center font-900 font-30 mb-0">Password Request</h1>
										<p class="bottom-0 text-center color-highlight font-11">Enter your phone number to (re)set your password.</p>
										<div class="input-style has-icon input-style-1 input-required pb-1">
												<!--												<i class="input-icon fa fa-user color-theme"></i>-->
												<span>Phone number</span>
												<em>(required)</em>
												<input placeholder="Phone number" type="text">
										</div>

										<a @click="requestPassword" class="mb-3 text-white font-900 btn bnt-icon btn-m btn-full mb-3 rounded-0 text-uppercase font-900 shadow-s bg-red1-light">Send</a>
										<div class="divider"></div>
										<div>
												<a href="#" class="chip chip-large">
														<i class="fa fa-check bg-green1-dark"></i>
														<strong class="font-400">Check your phone for a security pin</strong>
												</a>
										</div>
								</div>
						</div>
				</div>
		</div>
</template>

<script>
    import AppBar from "../../components/AppBar";
    export default {
        name: "PasswordRequest",
        components: {AppBar},
        methods: {
            requestPassword(){
							this.$router.push("/home")
            }
        }
    }
</script>

<style scoped>

</style>